import React from "react";
import { useAuth } from "../../context/AuthContext";
import UserDashboard from "./User/UserDashboard";
import LoadingSpinner from "../../components/LoadingSpinner";

function Dashboard() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner message="Loading dashboard..." />;
  }

  switch (user?.role) {
    case 'USER':
      return <UserDashboard />;
    default:
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800">Welcome to Taasa</h2>
            <p className="text-gray-600 mt-2">Your account is being set up.</p>
          </div>
        </div>
      );
  }
}

export default Dashboard;
